var React = require('react');

function Flecha (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#FFFFFF","points":"2.824,21.156 2.824,34.006 15.11,24.002 15.11,48.853 33.441,48.853 33.441,24.002 45.727,34.006 \n\t45.727,21.156 24.276,3.688 "}));
}

Flecha.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"48.249px","height":"51.575px","viewBox":"0 0 48.249 51.575","enableBackground":"new 0 0 48.249 51.575","xmlSpace":"preserve"};

module.exports = Flecha;

Flecha.default = Flecha;
